export default __webpack_public_path__ + "app/module/eficiencia-fiscal/view/configuracao/icms/excecao-confirmada/partials/isencao.html";